module.exports = __webpack_public_path__ + "img/Grupo 1030@2x.bb9a23b1.png";